<template>
  <div class="lamp-content">
    <el-form label-postion="left" label-width="100px">
      <el-form-item label="节目单名称">
        <el-input
          placeholder="请输入节目单名"
          v-model="programItem.programName"
        ></el-input>
      </el-form-item>
      <hr />
      <el-form-item
        label="时间段"
        v-for="(item, index) in programItem.content"
        :key="item.key"
        :class="{
          crossed: item.crossed,
        }"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="10">
            <el-slider
              range
              v-model="item.timeslots"
              :min="0"
              :max="86399"
              :step="900"
              @change="updateTime(item)"
              :format-tooltip="numberToTimeString"
            >
            </el-slider>
          </el-col>
          <el-col :span="4">
            <el-time-picker
              is-range
              v-model="item.timeslotsObj"
              @change="updateTimeNumber(item)"
              format="HH:mm"
              style="width: 100%"
            >
            </el-time-picker>
          </el-col>
          <el-col :span="3" align="right">选择媒体文件</el-col>
          <el-col :span="4">
            <el-select
              filterable 
              placeholder="请选择所属路灯"
              v-model="item.file"
              style="width: 100%"
            >
              <el-option
                v-for="t in mediaList"
                :key="t.id"
                :label="t.fileName"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="2">
            <el-button class="remove" type="danger" @click="removeTime(index)"
              >删除</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addTime">新建时间段</el-button>
      </el-form-item>
      <hr />
      <el-button
        type="primary"
        native-type="submit"
        @click.prevent="editprogram"
        >保存</el-button
      >
      <el-button type="error" @click="cancel">取消</el-button>
    </el-form>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import time from "@/utils/time"
import moment from "moment"
export default {
  name: "editProgram",
  props: {
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      crossed: false,
      programItem: {
        id: null,
        programName: "",
        content: [],
      },
      mediaList: []
    };
  },
  methods: {
    ...time,
    getStg() {
      this.programItem.id = this.editData.id
      this.programItem.programName = this.editData.programName
      let getTime=this.editData.time
      let getFileId=this.editData.fileId

      let timeArr = getTime.split(',')
      let fileIdArr = getFileId.split(',')
      for (let i=0; i<timeArr.length; i++) {
        
        let timeI=timeArr[i].split('-')
        this.programItem.content.push({
          timeslots: [
            this.HmToNumber(timeI[0]),
            this.HmToNumber(timeI[1]),
          ],
          timeslotsObj: [
            this.numberToTime(this.HmToNumber(timeI[0])),
            this.numberToTime(this.HmToNumber(timeI[1])),
          ],
          file: parseInt(fileIdArr[i]),
          crossed: false,
        });
        this.checkValid();
      }
      this.getMediaList(1)
    },
    updateTimeNumber(item) {
      this.checkValid();
      item.timeslots = [
        this.timeToNumber(item.timeslotsObj[0]),
        this.timeToNumber(item.timeslotsObj[1]),
      ];
    },
    updateTime(item) {
      this.checkValid();
      item.timeslotsObj = [
        this.numberToTime(item.timeslots[0]),
        this.numberToTime(item.timeslots[1]),
      ];
    },
    removeTime(index) {
      if (confirm("确定要删除这个时间段？")) {
        this.programItem.content.splice(index, 1);
        this.checkValid();
      }
    },
    editprogram() {
      let params = {
        id: this.programItem.id,
        programName: this.programItem.programName,
        time: "",
        fileId: 0
      };
      let status = ""
      let sfile = ""
      this.programItem.content
        .sort((x, y) => x.timeslotsObj[0] > y.timeslotsObj[0])
        .forEach((item, index) => {
          status +=
            [
              moment(item.timeslotsObj[0]).format("HH:mm") +
                "-" +
                moment(item.timeslotsObj[1]).format("HH:mm"),
            ] + ",";
          sfile += item.file + ",";
        });
      params.time = status.substring(0, status.length - 1);
      params.fileId = sfile.substring(0, sfile.length - 1);
      if (this.crossed === false) {
        axios({
          url: process.env.VUE_APP_BASE_API+'/v1/programGuides/manager/updateJieMuBill',
          method: 'post',
          data: qs.stringify(params)
        }).then(res => {
          if (res.data.code === 1000) {
            this.$message.success(res.data.message);
            this.$emit('closeMethod')
          } else {
            this.$message.error(res.data.message);
          }
        })
      } else {
        this.$message.error("请不要选择重复时间段")
      }
    },
    addTime() {
      this.programItem.content.push({
        key: Date.now(),
        file: '',
        timeslots: [0, 3600],
        timeslotsObj: [this.numberToTime(0), this.numberToTime(3600)],
      });
      this.checkValid();
    },
    checkValid(change) {
      this.crossed = false;
      const cross = (s1, s2) => {
        return s2.timeslots[0] < s1.timeslots[1];
      };
      for (let i = 0; i < this.programItem.content.length; i++) {
        for (let j = i + 1; j < this.programItem.content.length; j++) {
          const s1 = this.programItem.content[i];
          const s2 = this.programItem.content[j];
          if (s1.timeslots[0] < s2.timeslots[0]) {
            this.crossed = cross(s1, s2);
          } else {
            this.crossed = cross(s2, s1);
          }
          if (this.crossed) {
            s1.crossed = true;
            s2.crossed = true;
            return;
          } else {
            s1.crossed = false;
            s2.crossed = false;
          }
        }
      }
    },
    cancel() {
      this.$emit("closeMethod");
    },
    getMediaList(pageIndex) {
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/listPage',
        method: 'GET',
        params: {
          pageNum: pageIndex,
          pageSize: 2000
        },
      }).then(res => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.mediaList = resData.list;
        }
      })
    }
  },
  created() {
    this.getStg()
  },
  updated() {
    this.$emit('closeLoading')
  }
};
</script>

<style lang='less'>
.my_number {
  width: 120px;
  .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
}
.crossed .el-form-item__label,
.crossed .el-date-editor input,
.crossed .el-date-editor .el-input__icon {
  color: #ff4949 !important;
}
.crossed .el-slider__button,
.crossed .el-slider__bar {
  background: #ff4949 !important;
}
.crossed .el-slider__runway {
  background: #ffcdd2 !important;
}
.crossed .el-date-editor input {
  border-color: #ff4949 !important;
}
</style>